<template>
  <div class="h-100 d-block">
    <b-table
      class="h-100 d-flex"
      striped
      hover
      responsive
      bordered
      :fields="fields"
      :items="dataList"
      small
    >
      <template #cell(ytdSales)="data">
        {{ data.item.ytdSales | toNumber }}
      </template>
      <template #cell(yoyRate)="data">
        <b-button
          :id="'popover-yoyRate-' + data.item.id"
          variant="link"
          class="p-0 m-0 text-body font-weight-normal"
        >
          <div
            :class="data.item.yoyRate > 0? 'text-success' : 'text-danger'"
            class="font-weight-bold d-flex align-items-center justify-content-end"
          >
            %{{ data.item.yoyRate | toNumber }}
            <div>
              <FeatherIcon :icon="data.item.yoyRate > 0? 'ArrowUpIcon' : 'ArrowDownIcon'" />
            </div>
          </div>
        </b-button>
        <b-popover
          :target="'popover-yoyRate-' + data.item.id"
          triggers="hover"
          placement="left"
        >
          <div class="font-weight-bold font-small-2 text-center border-bottom">
            Bir önceki yıla göre
          </div>
          <div
            class="d-flex align-items-center w-100 justify-content-center"
            style="margin-top: 5px"
          >
            <div class="text-center pr-1 border-right">
              <div class="text-primary font-weight-bold font-small-2">
                {{ data.item.ytdLastYear }}
              </div>
              <div>{{ data.item.lastYtdSales | toNumber }}</div>
            </div>
            <div class="text-center pl-1">
              <div class="text-primary font-weight-bold font-small-2">
                {{ data.item.ytdThisYear }}
              </div>
              <div>{{ data.item.ytdSales | toNumber }}</div>
            </div>
          </div>
        </b-popover>
      </template>
      <template #cell(momRate)="data">
        <b-button
          :id="'popover-momRate-' + data.item.id"
          variant="link"
          class="p-0 m-0 text-body font-weight-normal"
        >
          <div
            :class="data.item.momRate > 0? 'text-success' : 'text-danger'"
            class="font-weight-bold d-flex align-items-center justify-content-end"
          >
            %{{ data.item.momRate | toNumber }}
            <div>
              <FeatherIcon :icon="data.item.momRate > 0? 'ArrowUpIcon' : 'ArrowDownIcon'" />
            </div>
          </div>
        </b-button>
        <b-popover
          :target="'popover-momRate-' + data.item.id"
          triggers="hover"
          placement="left"
        >
          <div class="font-weight-bold font-small-2 text-center border-bottom">
            Bir önceki aya göre
          </div>
          <div
            class="d-flex align-items-center justify-content-center"
            style="margin-top: 5px"
          >
            <div class="text-center pr-1 border-right">
              <div class="text-primary font-weight-bold font-small-2">
                {{ data.item.ytdLastYear }}
              </div>
              <div>{{ data.item.lastYearMtdSales | toNumber }}</div>
            </div>
            <div class="text-center pl-1">
              <div class="text-primary font-weight-bold font-small-2">
                {{ data.item.ytdThisYear }}
              </div>
              <div>{{ data.item.mtdSales | toNumber }}</div>
            </div>
          </div>
        </b-popover>
      </template>
      <template #cell(goalsRate)="data">
        <template v-if="data.item.goals > 0">
          <b-button
            :id="'popover-goalsRate-' + data.item.id"
            variant="link"
            class="p-0 m-0 text-body font-weight-normal"
          >
            <div
              :class="goalsClass(data.item.goalsRate)"
              class="font-weight-bold d-flex align-items-center justify-content-end"
            >
              %{{ data.item.goalsRate | toNumber }}
            </div>
          </b-button>
          <b-popover
            :target="'popover-goalsRate-' + data.item.id"
            triggers="hover"
            placement="left"
          >
            <div class="d-flex align-items-center">
              <div class="text-center pr-1 border-right">
                <div class="text-primary font-weight-bold font-small-2">
                  Satış Adet
                </div>
                <div>{{ data.item.mtdSales | toNumber }}</div>
              </div>
              <div class="text-center pl-1">
                <div class="text-primary font-weight-bold font-small-2">
                  Hedef
                </div>
                <div>{{ data.item.goals | toNumber }}</div>
              </div>
            </div>
          </b-popover>
        </template>
        <template v-else>
          <b-button
            :id="'popover-goalsRate-' + data.item.id"
            variant="link"
            class="p-0 m-0 text-body font-weight-normal"
          >
            <div
              class="font-weight-bold text-danger"
            >
              <FeatherIcon icon="HelpCircleIcon" />
            </div>
          </b-button>
          <b-popover
            :target="'popover-goalsRate-' + data.item.id"
            triggers="hover"
            placement="left"
          >
            <div>
              <div class="font-weight-bold text-danger">
                Eksik Bilgi
              </div>
              <div>Satış hedefi tanımsız.</div>
            </div>
          </b-popover>
        </template>
      </template>
      <template #cell(swapsRate)="data">
        <b-button
          :id="'popover-swapsRate-' + data.item.id"
          variant="link"
          class="p-0 m-0 text-body font-weight-normal"
        >
          <div
            class="d-flex align-items-center justify-content-end"
          >
            %{{ data.item.swapsRate | toNumber }}
          </div>
        </b-button>
        <b-popover
          :target="'popover-swapsRate-' + data.item.id"
          triggers="hover"
          placement="left"
        >
          <div class="d-flex align-items-center">
            <div class="text-center">
              <div class="text-primary font-weight-bold font-small-2">
                Takas Adet
              </div>
              <div>
                {{ data.item.swaps | toNumber }}
              </div>
            </div>
          </div>
        </b-popover>
      </template>
      <template #cell(connections)="data">
        {{ data.item.connections | toNumber }}
      </template>
      <template #cell(stocks)="data">
        {{ data.item.stocks | toNumber }}
      </template>
      <template #custom-foot>
        <b-tr>
          <b-th>
            Toplam
          </b-th>
          <b-th class="text-right">
            {{ grandTotals.ytdSales | toNumber }}
          </b-th>
          <b-th class="text-right">
            <b-button
              id="popover-yoyRate-totals"
              variant="link"
              class="p-0 m-0 text-body font-weight-normal"
            >
              <div
                :class="grandTotals.yoyRate > 0? 'text-success' : 'text-danger'"
                class="font-weight-bold d-flex align-items-center justify-content-end"
              >
                %{{ grandTotals.yoyRate | toNumber }}
                <div>
                  <FeatherIcon :icon="grandTotals.yoyRate > 0? 'ArrowUpIcon' : 'ArrowDownIcon'" />
                </div>
              </div>
            </b-button>
            <b-popover
              target="popover-yoyRate-totals"
              triggers="hover"
              placement="left"
            >
              <div class="font-weight-bold font-small-2 text-center border-bottom">
                Bir önceki yıla göre
              </div>
              <div
                class="d-flex align-items-center"
                style="margin-top: 5px"
              >
                <div class="text-center pr-1 border-right">
                  <div class="text-primary font-weight-bold font-small-2">
                    {{ grandTotals.ytdLastYear }}
                  </div>
                  <div>{{ grandTotals.lastYtdSales | toNumber }}</div>
                </div>
                <div class="text-center pl-1">
                  <div class="text-primary font-weight-bold font-small-2">
                    {{ grandTotals.ytdThisYear }}
                  </div>
                  <div>{{ grandTotals.ytdSales | toNumber }}</div>
                </div>
              </div>
            </b-popover>
          </b-th>
          <b-th class="text-right">
            <b-button
              id="popover-momRate-totals"
              variant="link"
              class="p-0 m-0 text-body font-weight-normal"
            >
              <div
                :class="grandTotals.momRate > 0? 'text-success' : 'text-danger'"
                class="font-weight-bold d-flex align-items-center justify-content-end"
              >
                %{{ grandTotals.momRate | toNumber }}
                <div>
                  <FeatherIcon :icon="grandTotals.momRate > 0? 'ArrowUpIcon' : 'ArrowDownIcon'" />
                </div>
              </div>
            </b-button>
            <b-popover
              target="popover-momRate-totals"
              triggers="hover"
              placement="left"
            >
              <div class="font-weight-bold font-small-2 text-center border-bottom">
                Bir önceki aya göre
              </div>
              <div
                class="d-flex align-items-center justify-content-center w-100"
                style="margin-top: 5px"
              >
                <div class="text-center pr-1 border-right">
                  <div class="text-primary font-weight-bold font-small-2">
                    {{ grandTotals.ytdLastYear }}
                  </div>
                  <div>{{ grandTotals.lastYearMtdSales | toNumber }}</div>
                </div>
                <div class="text-center pl-1">
                  <div class="text-primary font-weight-bold font-small-2">
                    {{ grandTotals.ytdThisYear }}
                  </div>
                  <div>{{ grandTotals.mtdSales | toNumber }}</div>
                </div>
              </div>
            </b-popover>
          </b-th>
          <b-th class="text-right">
            <template v-if="grandTotals.goals > 0">
              <b-button
                id="popover-goalsRate-totals"
                variant="link"
                class="p-0 m-0 text-body font-weight-normal"
              >
                <div
                  :class="goalsClass(grandTotals.goalsRate)"
                  class="font-weight-bold d-flex align-items-center justify-content-end"
                >
                  %{{ grandTotals.goalsRate | toNumber }}
                </div>
              </b-button>
              <b-popover
                target="popover-goalsRate-totals"
                triggers="hover"
                placement="left"
              >
                <div class="d-flex align-items-center">
                  <div class="text-center pr-1 border-right">
                    <div class="text-primary font-weight-bold font-small-2">
                      Satış Adet
                    </div>
                    <div>{{ grandTotals.mtdSales | toNumber }}</div>
                  </div>
                  <div class="text-center pl-1">
                    <div class="text-primary font-weight-bold font-small-2">
                      Hedef
                    </div>
                    <div>{{ grandTotals.goals | toNumber }}</div>
                  </div>
                </div>
              </b-popover>
            </template>
            <template v-else>
              <b-button
                id="popover-goalsRate-totals"
                variant="link"
                class="p-0 m-0 text-body font-weight-normal"
              >
                <div
                  class="font-weight-bold text-danger"
                >
                  <FeatherIcon icon="HelpCircleIcon" />
                </div>
              </b-button>
              <b-popover
                target="popover-goalsRate-totals"
                triggers="hover"
                placement="left"
              >
                <div>
                  <div class="font-weight-bold text-danger">
                    Eksik Bilgi
                  </div>
                  <div>Satış hedefi tanımsız.</div>
                </div>
              </b-popover>
            </template>
          </b-th>
          <b-th class="text-right">
            <b-button
              id="popover-swapsRate-totals"
              variant="link"
              class="p-0 m-0 text-body font-weight-normal"
            >
              <div
                class="d-flex align-items-center justify-content-end"
              >
                %{{ grandTotals.swapsRate | toNumber }}
              </div>
            </b-button>
            <b-popover
              target="popover-swapsRate-totals"
              triggers="hover"
              placement="left"
            >
              <div class="d-flex align-items-center">
                <div class="text-center">
                  <div class="text-primary font-weight-bold font-small-2">
                    Takas Adet
                  </div>
                  <div>
                    {{ grandTotals.swaps | toNumber }}
                  </div>
                </div>
              </div>
            </b-popover>
          </b-th>
          <b-th class="text-right">
            {{ grandTotals.connections | toNumber }}
          </b-th>
          <b-th class="text-right">
            {{ grandTotals.stocks | toNumber }}
          </b-th>
        </b-tr>
      </template>
    </b-table>
  </div>
</template>
<script>
import {
  BTable, BTh, BTr, BButton, VBPopover, BPopover,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'TablePerformance',
  components: {
    BTr,
    BTh,
    BTable,
    BButton,
    BPopover,
  },
  directives: {
    'b-popover': VBPopover,
    Ripple,
  },
  props: {
    dataList: {
      type: Array,
      required: true,
    },
    grandTotals: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'title',
          label: 'Marka',
          sortable: true,
          thClass: 'font-small-2 align-middle',
          tdClass: 'font-weight-bold text-body',
        },
        {
          key: 'ytdSales',
          label: 'Yıllık Satış',
          sortable: true,
          thClass: 'font-small-2 width-100 text-right align-middle',
          tdClass: 'text-right text-body',
        },
        {
          key: 'yoyRate',
          label: 'YILLIK YIL BAZINDA SATIŞ %',
          sortable: true,
          thClass: 'font-small-2 width-100 text-right align-middle',
          tdClass: 'text-right text-nowrap text-body',
        },
        {
          key: 'momRate',
          label: 'YILLIK AY BAZINDA SATIŞ %',
          sortable: true,
          thClass: 'font-small-2 width-100 text-right align-middle',
          tdClass: 'text-right text-nowrap text-body',
        },
        {
          key: 'goalsRate',
          label: 'Hedef',
          sortable: true,
          thClass: 'font-small-2 width-100 text-right align-middle',
          tdClass: 'text-right text-nowrap text-body',
        },
        {
          key: 'swapsRate',
          label: 'Takas',
          sortable: true,
          thClass: 'font-small-2 width-100 text-right align-middle',
          tdClass: 'text-right text-nowrap text-body',
        },
        {
          key: 'connections',
          label: 'Bağlantı',
          sortable: true,
          thClass: 'font-small-2 width-100 text-right align-middle',
          tdClass: 'text-right text-nowrap text-body',
        },
        {
          key: 'stocks',
          label: 'Stok',
          sortable: true,
          thClass: 'font-small-2 width-100 text-right align-middle',
          tdClass: 'text-right text-nowrap text-body',
        },
      ],
    }
  },
  methods: {
    goalsClass(val) {
      let className = ''
      if (val === 0) {
        className = 'text-danger'
      } else if (val > 0 && val < 50) {
        className = 'text-warning'
      } else if (val > 50 && val < 75) {
        className = 'text-info'
      } else if (val > 75) {
        className = 'text-success'
      }
      return className
    },
  },
}
</script>
